import IconAsMaskImage from '../IconAsMaskImage'

function AddStar({ pureSvg, className, color, ...rest }) {
  const svg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6876 20.8628C13.1768 20.9533 12.6504 21 12.1143 21C7.14336 21 3.11426 16.9709 3.11426 12C3.11426 7.0301 7.14336 3 12.1143 3C17.0842 3 21.1143 7.0301 21.1143 12C21.1143 12.8329 21.0014 13.6385 20.7893 14.4033"
        stroke="#0D0B20"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.0693 16.5762V20.2212"
        stroke="#0D0B20"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.8931 18.4004H16.2451"
        stroke="#0D0B20"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.1143 7.75C12.7341 9.78653 14.3278 11.3803 16.3643 12.0002C14.3278 12.62 12.7341 14.2138 12.1143 16.2504C11.4944 14.2138 9.9007 12.62 7.86426 12.0002C9.9007 11.3803 11.4944 9.78653 12.1143 7.75Z"
        stroke="#0D0B20"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default AddStar
